module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0112.jpg?v=684e8654";